if (!customElements.get("benefits-cloud")) {
  class BenefitsCloud extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.items = [];
      this.isDesktop = false;
      this.mediaQuery = null;
      this.onMouseMove = this.onMouseMove.bind(this);
      this.onMouseLeave = this.onMouseLeave.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector("[data-benefits-track]");
      this.items = this.track
        ? Array.from(this.track.querySelectorAll("[data-benefits-item]"))
        : [];
      this.mediaQuery = window.matchMedia("(min-width: 768px)");
      this.isDesktop = this.mediaQuery.matches;
      this.classList.toggle("is-desktop", this.isDesktop);
      this.classList.toggle("is-mobile", !this.isDesktop);

      this.addEventListener("mousemove", this.onMouseMove);
      this.addEventListener("mouseleave", this.onMouseLeave);
      this.mediaQuery.addEventListener("change", this.onMediaChange);
    }

    disconnectedCallback() {
      this.removeEventListener("mousemove", this.onMouseMove);
      this.removeEventListener("mouseleave", this.onMouseLeave);
      this.mediaQuery?.removeEventListener("change", this.onMediaChange);
    }

    onMediaChange(event) {
      this.isDesktop = event.matches;
      this.classList.toggle("is-desktop", this.isDesktop);
      this.classList.toggle("is-mobile", !this.isDesktop);
      this.items = this.track
        ? Array.from(this.track.querySelectorAll("[data-benefits-item]"))
        : [];
      this.resetParallax();
    }

    onMouseMove(event) {
      if (!this.isDesktop || !this.track) return;
      const rect = this.track.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const relX = (event.clientX - rect.left) / rect.width - 0.5;
      const relY = (event.clientY - rect.top) / rect.height - 0.5;
      this.items.forEach((item) => {
        const speed = 8;
        const offsetX = relX * speed * 6;
        const offsetY = relY * speed * 6;
        item.style.setProperty("--tx", `${offsetX}px`);
        item.style.setProperty("--ty", `${offsetY}px`);
      });
    }

    onMouseLeave() {
      if (!this.isDesktop) return;
      this.resetParallax();
    }

    resetParallax() {
      this.items.forEach((item) => {
        item.style.setProperty("--tx", "0px");
        item.style.setProperty("--ty", "0px");
      });
    }

  }

  customElements.define("benefits-cloud", BenefitsCloud);
}
